import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Selectors/Select/mobile';
import useModel from 'features/sportHistory/model/useModel';
import { selectSportHistoryLocale } from 'features/sportHistory/redux/selectors';
import Spinner from 'components/Spinner/view/desktop';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/view/desktop';

import FilterBlock from './FilterBlock/FilterBlock';

import SportHistoryItem from './SportHistoryItem/SportHistoryItem';

import { tableHeaders } from '../../../data';

import './SportHistory.scss';

const b = block('sport-history');

const SportHistory = () => {
  const locale = useSelector(selectSportHistoryLocale);
  const locale2 = useSelector(s => s.locale.locale);
  const { output, input } = useModel();

  return (
    <div className={b()}>
      <Spinner isLoading={output.actionProcessing} />
      <FilterBlock filter={input} />
      <div className={b('items-on-page')}>
        <h2 className={b('items-on-page-title')}>{locale.status.title}</h2>
        <div className={b('items-on-page-text')}>{locale2.elementsOnPage}:</div>
        <div className={b('items-on-page-select')}>
          <Select items={input.values.itemsOnPage} onChange={input.handleItemsOnPageChange} color="grey" />
        </div>
      </div>
      <div className={b('result')}>
        <div className={b('header')}>
          {tableHeaders.map((item, index) =>
            item !== 'blank' ? (
              <div key={index} className={b('header-col')}>
                {locale.headers?.[item] ?? item}
              </div>
            ) : null,
          )}
        </div>
        {output.coupons.items.length
          ? output.coupons.items.map(item => (
            <SportHistoryItem key={item.id} item={item} />
          ))
          : <div className={b('no-results')}>{locale2.noResults}</div>}
        <div className={b('pagination')}>
          <div>{output.coupons.count > 0 ? `${output.coupons.count} ${locale.count}` : locale.noItems}</div>
          <PaginatorSwitcher
            onPageClick={input.handlePageChange}
            count={output.coupons.count}
            currentPage={input.values.page}
            itemsOnPage={output.activeItemsOnPage}
          />
        </div>
      </div>
    </div>
  );
};

export default SportHistory;
